import React from 'react';
import RocketIcon from '@app/icons/RocketIcon.tsx';
import Ringil from '@app/icons/Ringil.tsx';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

interface MaintenanceLayoutProps {
  title?: string;
}

const MaintenanceLayout: React.FC<MaintenanceLayoutProps> = ({ title }) => {
  return (
    <>
      {title && <title>{title}</title>}
      <div className="h-screen flex flex-col items-center justify-center bg-[#F7F8F9] p-4">
        <RocketIcon className="w-16 h-16 text-[#FF5C38] mb-[36px]" />
        <div className={twMerge(clsx('max-w-[686px] w-full mx-auto p-8 rounded-lg shadow-lg bg-white mt-[36px]', 'flex flex-col items-start text-left gap-6'))}>
          <div className="space-y-6">
            <div className="space-y-2">
              <h1 className="text-2xl font-semibold text-gray-900">Pracujeme na tom, aby byl Ringil ještě lepší!</h1>
              <p className="text-gray-600">
                Omlouváme se za dočasné potíže! Pracujeme na vylepšení Ringilu a brzy se k vám vrátíme. Děkujeme za vaši trpělivost, snažíme se to vyřešit co nejrychleji.
              </p>
            </div>

            <div className="space-y-2">
              <h2 className="text-2xl font-semibold text-gray-900">We are working to make Ringil even better!</h2>
              <p className="text-gray-600">
                Sorry for the temporary inconvenience! We are working on improving Ringil and will be back to you soon. Thank you for your patience, we are trying to
                resolve this as quickly as possible.
              </p>
            </div>
          </div>
        </div>
        <Ringil className="fixed bottom-[60px]" />
      </div>
    </>
  );
};

export default MaintenanceLayout;
